<template>
  <div class="DataTable">
    <!-- <div data-v-fae5bece class="v-card__title headline lighten-2 v-card__title--primary">Repromaterijali</div> -->

    <div
      data-v-fae5bece
      class="v-card__title headline lighten-2 v-card__title--primary"
      style="padding-left: 16px; padding-bottom: 0px; padding-top: 0px"
    >
      <div>Repromaterijali</div>

      <button
        id="closeModalBtn"
        @click.prevent="closeModalInModal_izbor_redova"
        class="v-btn v-btn--flat white"
        v-if="operationType !== undefined && operationType !== null"
      >
        <v-icon>close</v-icon>
      </button>
    </div>

    <v-form ref="form" v-model="valid" lazy-validation>
      <!--<v-layout row wrap>-->
      <!--<v-flex xs8>-->
      <!--<v-text-field-->
      <!--v-model="ID"-->
      <!--label="ID" readonly-->
      <!--&gt;</v-text-field>-->
      <!--</v-flex>-->
      <!--</v-layout> &lt;!&ndash; /.ID &ndash;&gt;-->

      <v-layout row wrap>
        <v-flex xs4 pa-2>
          <v-text-field
            id="input-usage"
            v-model="naziv"
            label="Naziv"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-select
            v-model="operation_to_select"
            :items="operation_to_items"
            item-text="name"
            item-value="name"
            label="Operacija"
            persistent-hint
            return-object
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            v-on:change="changeOperation"
            :disabled="operationType !== null && operationType !== undefined && operationType !== 'Magacin'"
          ></v-select>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-autocomplete
            v-model="additiv_group_to_select"
            :items="additiv_group_to_items"
            item-text="name"
            item-value="id"
            label="Grupa repromaterijala"
            persistent-hint
            return-object
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            v-on:change="changeAdittiveGroup"
            :disabled="operationType !== null && operationType !== undefined && operationType !== 'Magacin'"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-autocomplete
            v-model="group_jm_select"
            :items="group_jm_items"
            item-text="name"
            item-value="id"
            label="Grupa JM"
            persistent-hint
            return-object
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            v-on:change="changeGroup"
            :disabled="disable_group"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs2 pa-2 v-if="vidljiva_zapremina === true">
          <v-text-field
            v-model="zapremina"
            label="Zapremina (u litrima)"
            type="number"
            min="0"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2 v-if="vidljiva_karenca">
          <v-text-field
            v-model="karenca"
            label="Karenca"
            type="number"
            min="0"
            suffix="dana"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <!-- suffix="L" -->

      <v-layout row wrap>
        <v-flex xs12 pa-2>
          <v-textarea
            v-model="opis"
            name="input-5-1"
            class="Description"
            label="Opis"
          ></v-textarea>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs12>
          <v-btn :disabled="!valid" @click="submit" class="AppButtonFilled"
            >Sačuvaj</v-btn
          >
          <v-btn @click="clear" class="AppButtonOutlined">odustani</v-btn>
        </v-flex>
      </v-layout>
      <!-- /.Action buttons -->
    </v-form>
    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import { serverBus } from "../main";
import {
  readJSON,
  prevediOperacije,
  prevediOperacije2,
} from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  name: "AdditiveItem",
  components: {
    TokenComponent,
  },
  data: () => ({
    valid: true,
    ID: "0",
    naziv: "",
    opis: "",
    additiv_group_to_items: [],
    additiv_group_to_select: 0,
    operation_to_items: [],
    operation_to_select: 0,
    group_jm_select: 0,
    group_jm_items: [],
    load: 0,
    zapremina: 0,
    zapreminaPom: undefined,
    vidljiva_zapremina: false,
    disable_group: false,
    izmena: 0,
    naziv_pomocni: "",
    karenca: undefined,
    vidljiva_karenca: false
  }),
  props: ["operationType"],
  watch: {
    operationType: function (val) {
      if (val !== null && val !== undefined && val !== 'Magacin') {
        let pomObj = val.split("|");

        // obj = this.phase_to_items.findIndex((x) => x.id === id);

        this.operation_to_select = pomObj[0];
        this.additiv_group_to_select = {
          id: pomObj[1],
        };
      }
    },
  },

  methods: {
    closeModalInModal_izbor_redova() {
      let complex;

      complex = {
        name: this.naziv_pomocni,
      };

      this.$emit("close", complex);
    },
    newSifarnik() {
      this.naziv_pomocni = this.naziv;

      var pom_additiv_group_to_select;

      if (this.additiv_group_to_select.id === null)
        pom_additiv_group_to_select = this.additiv_group_to_select;
      else pom_additiv_group_to_select = this.additiv_group_to_select.id;

      var complexAditiveObject = {
        id: pom_additiv_group_to_select,
      };

      var pom_jm_group_to_select;

      if (typeof this.group_jm_select.id !== "undefined")
        pom_jm_group_to_select = this.group_jm_select.id;
      else pom_jm_group_to_select = this.group_jm_select;

      var complexJMAditiveObject = {
        id: pom_jm_group_to_select,
      };

      if (this.zapremina !== 0)
        var complexObject = {
          name: this.naziv,
          description: this.opis,
          additiveGroup: complexAditiveObject,
          bottleVolumeInLiters: this.zapremina,
          unitOfMeasureGroup: complexJMAditiveObject,
          waitingPeriod: this.karenca !== undefined ? this.karenca : null
        };
      else
        var complexObject = {
          name: this.naziv,
          description: this.opis,
          additiveGroup: complexAditiveObject,
          unitOfMeasureGroup: complexJMAditiveObject,
          waitingPeriod: this.karenca !== undefined ? this.karenca : null
        };

      this.$http
        .post(
          this.globalServiceLocation + this.globalPort + "/additiv/create",
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          if (this.operationType !== undefined && this.operationType !== null)
            this.closeModalInModal_izbor_redova();
          else serverBus.$emit("refresh_additive");
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/additiv/create",
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      if (
                        this.operationType !== undefined &&
                        this.operationType !== null
                      )
                        this.closeModalInModal_izbor_redova();
                      else serverBus.$emit("refresh_additive");
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnik() {
      var pom_additiv_group_to_select;

      if (this.additiv_group_to_select.id == null)
        pom_additiv_group_to_select = this.additiv_group_to_select;
      else pom_additiv_group_to_select = this.additiv_group_to_select.id;

      var complexAditiveObject = {
        id: pom_additiv_group_to_select,
      };

      var pom_jm_group_to_select;

      if (typeof this.group_jm_select.id !== "undefined")
        pom_jm_group_to_select = this.group_jm_select.id;
      else pom_jm_group_to_select = this.group_jm_select;

      var complexJMAditiveObject = {
        id: pom_jm_group_to_select,
      };

      if (this.zapremina !== 0)
        var complexObject = {
          id: this.ID,
          name: this.naziv,
          description: this.opis,
          additiveGroup: complexAditiveObject,
          bottleVolumeInLiters: this.zapremina,
          unitOfMeasureGroup: complexJMAditiveObject,
          waitingPeriod: this.karenca !== undefined ? this.karenca : null
        };
      else
        var complexObject = {
          id: this.ID,
          name: this.naziv,
          description: this.opis,
          additiveGroup: complexAditiveObject,
          unitOfMeasureGroup: complexJMAditiveObject,
          waitingPeriod: this.karenca !== undefined ? this.karenca : null
        };

      // // console.log(JSON.stringify(complexObject));

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/additiv/update/" +
            this.ID,
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          serverBus.$emit("refresh_additive");
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/additiv/update/" +
                        this.ID,
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      serverBus.$emit("refresh_additive");
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.ID != "" && this.ID != "0") {
          this.changeSifarnik();
        } else {
          this.newSifarnik();
        }

        this.clear();
      }
    },
    clear() {
      this.$refs.form.reset();
      this.ID = 0;

      this.izmena = 0;
      this.zapreminaPom = undefined;
    },
    changeGroup(a) {
      // // console.log(a);
      if (typeof a !== "undefined")
        if (typeof a.id !== "undefined")
          if (a.id === 5) {
            let pomAditiv;

            if (typeof this.additiv_group_to_select.id === "undefined")
              pomAditiv = this.additiv_group_to_select;
            else pomAditiv = this.additiv_group_to_select.id;

            var indeks = this.additiv_group_to_items.findIndex(
              (x) => x.id === pomAditiv
            );

            if (indeks >= 0) {
              if (this.additiv_group_to_items[indeks].enumLabel === "bottle") {
                this.vidljiva_zapremina = true;
                this.zapremina = this.zapreminaPom;
              } else {
                this.vidljiva_zapremina = false;
                this.zapremina = null;
              }
            }
          } else {
            this.vidljiva_zapremina = false;
            this.zapremina = null;
          }
        else if (a === 5) {
          let pomAditiv;
          if (typeof this.additiv_group_to_select.id === "undefined")
            pomAditiv = this.additiv_group_to_select;
          else pomAditiv = this.additiv_group_to_select.id;

          var indeks = this.additiv_group_to_items.findIndex(
            (x) => x.id === pomAditiv
          );

          if (indeks >= 0)
            if (
              typeof this.additiv_group_to_items[indeks].enumLabel !==
              "undefined"
            )
              if (this.additiv_group_to_items[indeks].enumLabel === "bottle") {
                this.vidljiva_zapremina = true;
                this.zapremina = this.zapreminaPom;
              } else {
                this.vidljiva_zapremina = false;
                this.zapremina = null;
              }
        } else {
          this.vidljiva_zapremina = false;
          this.zapremina = null;
        }
    },
    // changeAdittiveGroup(a){
    //     // // console.log(a);
    //     if (typeof a !== "undefined")
    //       if(a.id === 1){

    //         var indeks = this.additiv_group_to_items.findIndex(x => x.id === a.id);

    //         if (this.additiv_group_to_items[indeks].enumLabel === "bottle")
    //           if (typeof this.group_jm_select !== "undefined")
    //             if (typeof this.group_jm_select.id !== "undefined")
    //               if (this.group_jm_select.id === 5)
    //                 this.vidljiva_zapremina = true;
    //               else
    //                 this.vidljiva_zapremina = false;
    //             else
    //               this.vidljiva_zapremina = false;
    //           else
    //               this.vidljiva_zapremina = false;
    //         else
    //           this.vidljiva_zapremina = false;
    //       }
    //       else
    //         this.vidljiva_zapremina = false;
    //     else
    //       this.vidljiva_zapremina = false;
    // },
    changeAdittiveGroup(a) {
      // // console.log(a);
      if (typeof a !== "undefined")
        if (a.id === 1) {
          if (a.operation === "BOTTLING") {
            this.group_jm_select = 5;
            this.disable_group = true;

            if (a.id === 1) {
              this.vidljiva_zapremina = true;
              this.zapremina = this.zapreminaPom;
            } else {
              this.vidljiva_zapremina = false;
              this.zapremina = null;
              this.disable_group = false;
            }
          } else {
            this.vidljiva_zapremina = false;
            this.zapremina = null;
            this.disable_group = false;
          }
        } else {
          if (a.operation === "BOTTLING") {
            this.group_jm_select = 5;
            this.disable_group = true;

            var indeks = this.additiv_group_to_items.findIndex(
              (x) => x.id === a.id
            );

            if (indeks > -1)
              if (this.additiv_group_to_items[indeks].enumLabel === "bottle") {
                this.vidljiva_zapremina = true;
                this.zapremina = this.zapreminaPom;
              } else {
                this.vidljiva_zapremina = false;
                this.zapremina = null;
              }
            else {
              this.vidljiva_zapremina = false;
              this.zapremina = null;
            }
          } else this.disable_group = false;
        }
      else {
      }
    },
    changeOperation(a) {
      this.vidljiva_zapremina = false;
      this.zapremina = null;
      

      this.load = this.load + 1;

      

      if (typeof a !== "undefined") {
        if (a.id === undefined) {
          if (a !== undefined) {
            // this.PreostaloUTanku(a);
            this.getAllGroups(prevediOperacije(a));

            if(a === "Vinograd")
              this.vidljiva_karenca = true;
            else
              this.vidljiva_karenca = false;

            if (this.load > 1) this.additiv_group_to_select = undefined;
          } else if (typeof this.operation_to_select === "undefined") {
            this.operation_to_select = undefined;
          }
        } else {
          if(a.id === "Vinograd")
              this.vidljiva_karenca = true;
            else
              this.vidljiva_karenca = false;

          this.getAllGroups(prevediOperacije(a.id));

          if (this.load > 1) this.additiv_group_to_select = undefined;
        }
      }
    },
    getAllOperations() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/additiv_group/operation",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          let array1 = response.data;

          array1.forEach(function (part, index) {
            this[index] = prevediOperacije2(this[index]);
          }, array1);

          this.operation_to_items = array1;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/additiv_group/operation",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      let array1 = response.data;

                      array1.forEach(function (part, index) {
                        this[index] = prevediOperacije2(this[index]);
                      }, array1);

                      this.operation_to_items = array1;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllGroups(a) {
      // // console.log(localStorage.getItem('user-token'));
      // // console.log(a);

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/additiv_group/operation/" +
            a,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // console.log(this.additiv_group_to_select);
          this.additiv_group_to_items = response.data;

          let pomAditiv;

          if (typeof this.additiv_group_to_select !== "undefined") {
            if (typeof this.additiv_group_to_select.id === "undefined")
              pomAditiv = this.additiv_group_to_select;
            else pomAditiv = this.additiv_group_to_select.id;

            var indeks = this.additiv_group_to_items.findIndex(
              (x) => x.id === pomAditiv
            );

            if (this.additiv_group_to_items[indeks].enumLabel === "bottle") {
              this.vidljiva_zapremina = true;
              this.zapremina = this.zapreminaPom;
            } else {
              this.vidljiva_zapremina = false;
              this.zapremina = null;
            }
          } else if (this.operationType !== undefined) {
            console.log(this.operationType)
            if(this.operationType !== 'Magacin'){
              var indeks = this.additiv_group_to_items.findIndex(
              (x) => x.id === Number(this.operationType.split("|")[1])
            );

            this.additiv_group_to_select = this.additiv_group_to_items[indeks];

            if (this.additiv_group_to_items[indeks].enumLabel === "bottle") {
              this.vidljiva_zapremina = true;
              this.zapremina = this.zapreminaPom;
            } else {
              this.vidljiva_zapremina = false;
              this.zapremina = null;
            }
            }
          }
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/additiv_group/operation/" +
                        a,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // console.log(this.additiv_group_to_select);
                      this.additiv_group_to_items = response.data;

                      let pomAditiv;

                      if (typeof this.additiv_group_to_select !== "undefined") {
                        if (
                          typeof this.additiv_group_to_select.id === "undefined"
                        )
                          pomAditiv = this.additiv_group_to_select;
                        else pomAditiv = this.additiv_group_to_select.id;

                        var indeks = this.additiv_group_to_items.findIndex(
                          (x) => x.id === pomAditiv
                        );

                        if (
                          this.additiv_group_to_items[indeks].enumLabel ===
                          "bottle"
                        ) {
                          this.vidljiva_zapremina = true;
                          this.zapremina = this.zapreminaPom;
                        } else {
                          this.vidljiva_zapremina = false;
                          this.zapremina = null;
                        }
                      }
                    })
                    .catch((e) => {
                      // console.log(e);

                      // // console.log(e.response);
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllGrupaJediniceMere() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/unit_of_measure_group/for_additive",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          this.group_jm_items = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/unit_of_measure_group/for_additive",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.group_jm_items = response.data;
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
  },
  mounted() {
    this.clear();
    this.getAllOperations();
    // this.getAllGroups();
    this.getAllGrupaJediniceMere();

    serverBus.$on("applied_additive", (item) => {
      this.izmena = 1;

      // // console.log(item);
      this.ID = item.id;
      this.naziv = item.name;
      this.opis = item.description;

      this.karenca = item.waitingPeriod;

      this.load = 0;

      if (item.additiveGroup !== null) {
        this.operation_to_select = prevediOperacije2(
          item.additiveGroup.operation
        );

        this.additiv_group_to_select = item.additiveGroup;
      } else {
        this.operation_to_select = undefined;
        this.additiv_group_to_select = undefined;
      }

      if (item.additiveGroup.operation === "BOTTLING") {
        this.disable_group = true;
        // this.group_jm_select = 5;
        this.vidljiva_zapremina = true;
        this.zapremina = this.zapreminaPom;
      } else this.disable_group = false;

      this.zapremina = item.bottleVolumeInLiters;
      this.zapreminaPom = item.bottleVolumeInLiters;

      if (item.unitOfMeasureGroup !== null){
        // this.group_jm_select = item.unitOfMeasureGroup;
        

        let ind = this.group_jm_items.findIndex((x) => x.id === item.unitOfMeasureGroup.id);

        if(ind >= 0)
          this.group_jm_select =  this.group_jm_items[ind];
      }
      else this.group_jm_select = undefined;
    });
  },
};
</script>

<style lang="scss" scoped>
// .additiveItemComponentForm {
//   max-width: 430px;
// }
@import "./../assets/sass/parts/modalStyles";

.Description textarea {
  height: 40px;
}

// .v-input.v-text-field {
// 	margin: 0px;
// }

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}
</style>
